<template>
  <section
    class="section--hero"
    :style="{ backgroundImage: 'url(../../static/assets/' + bgImg + locale + '.jpg)' }">
    <div class="container">
      <div class="hero__content">
        <h1>{{ $t("hero.makeAMolecule") }}</h1>
        <h2 class="text--white hero__text"> {{subtitle}}</h2>
      </div>
    </div>
    <button v-scroll-to="'#scrollToOnLoad'" class="hero__scroll-down">
      <img src="@/assets/ico_scroll-down.svg" class="animation--scroll-down" alt="">
    </button>
  </section>
</template>

<script>
export default {
  props: ['bgImg', 'subtitle'],
  data() {
    return {
      locale: localStorage.getItem('lang'),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/helpers/_variables.scss";
@import "../styles/helpers/_include-media.scss";

.section--hero {
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  @include media('<xl') {
    padding-top: 295px;
    padding-bottom: 219px;
  }
}
.hero {
  &__content {
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%);
    left: 50%;
    text-align: center;
    text-shadow: 0 0 15px $color--black;
    @include media('<lg') {
      left: 49%;
    }
  }
  &__text {
    @include media('<lg') {
      font-size: 18px;
      font-weight: 400;
    }
  }
  &__scroll-down {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    text-transform: uppercase;
    img {
      height: 20px;
      width: 100px;
    }
  }
}
.animation--scroll-down{
  position: relative;
  animation: scrollDown 1.5s ease-in-out infinite;
}
@keyframes scrollDown {
    0% {
      opacity: 0;
      top: -25px
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      top: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue